import AppContext from './../contexts/AppContext';
import { useContext, useState, useEffect } from 'react';
import ConfigContext from '../contexts/ConfigContext';

interface IconArrowProps {
  direction?: 'right' | 'left';
  color?: string;
}

export default function SlideProgress({ percentage }: any) {
  const { isDebrandedVersion, features } = useContext(ConfigContext);
  const {
    slides,
    currentSlide,
    goToNextSlide,
    goToPreviousSlide,
    loadingRoofShade,
  } = useContext(AppContext);

  const [isSelected, setIsSelected] = useState(false);
  const [startedSelected, setStartedSelected] = useState(false);

  useEffect(() => {
    const slide = slides[currentSlide];
    setIsSelected(
      (slide.additionalFields
        ? (slide.selectedValue || slide.allowNullValue) &&
          Object.keys(slide.additionalFields).every((key) => {
            return !!slide.additionalFields[key];
          })
        : !!slide.selectedValue) &&
        ((currentSlide < slides.length - 1
          ? slides[currentSlide + 1].selectedValue
          : true) ||
          startedSelected)
    );
  }, [currentSlide, slides, startedSelected]);

  useEffect(() => {
    setStartedSelected(!!slides[currentSlide].selectedValue);
  }, [currentSlide]);

  if (features.showSunnyBot) return null;

  return (
    <div
      className={`relative flex justify-end items-center z-0 ${
        features.showLanderConcept ? 'mt-[-10px] mb-12' : 'my-4'
      } md:my-0`}>
      <div className="grow">
        <div
          className={`bg-white md:bg-[#F4F3F0] h-2.5 rounded-full relative overflow-hidden`}>
          <div
            className={`${
              isDebrandedVersion ? 'bg-[#5ecf7f]' : 'bg-enph-orange'
            } h-full absolute left-0 top-0'`}
            style={{
              width: ` ${percentage || 0}%`,
              transition: 'width 0.5s',
            }}></div>
        </div>
      </div>
      <div className="flex">
        <button
          type="button"
          className="p-[1px] ml-4 md:ml-[30px] transition-opacity duration-300 disabled:opacity-100"
          disabled={currentSlide === 0}
          onClick={goToPreviousSlide}
          data-zuko-id={`${slides[currentSlide]?.key}_go_to_previous_slide`}>
          <IconArrow
            color={currentSlide > 0 ? '#3C3C3C' : '#dcdcd6'}
            direction="left"
          />
        </button>
        <button
          type="button"
          className="p-[1px] ml-2 transition-opacity duration-300 disabled:opacity-100"
          disabled={
            !isSelected ||
            currentSlide === slides.length - 1 ||
            loadingRoofShade ||
            (slides[currentSlide].key === 'property' &&
              slides[currentSlide].selectedValue !== 'Single Family Home')
          }
          onClick={goToNextSlide}
          data-zuko-id={`${slides[currentSlide]?.key}_go_to_next_slide`}>
          <IconArrow
            color={
              !isSelected ||
              currentSlide === slides.length - 1 ||
              loadingRoofShade ||
              (slides[currentSlide].key === 'property' &&
                slides[currentSlide].selectedValue !== 'Single Family Home')
                ? '#dcdcd6'
                : '#3C3C3C'
            }
          />
        </button>
      </div>
    </div>
  );
}

function IconArrow({ color, direction }: IconArrowProps) {
  const widthClasses = 'w-[36px] h-[36px]';
  return (
    <div
      className={
        direction !== 'left' ? `rotate-180 ${widthClasses}` : widthClasses
      }>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" />
        <path
          d="M11.5 7L8.5 10L11.5 13"
          stroke={color || 'black'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          stroke={color || 'black'}
        />
      </svg>
    </div>
  );
}
